import { render, staticRenderFns } from "./UpdateSent.vue?vue&type=template&id=3cddbbec&scoped=true&"
import script from "./UpdateSent.vue?vue&type=script&lang=js&"
export * from "./UpdateSent.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSent.vue?vue&type=style&index=0&id=3cddbbec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cddbbec",
  null
  
)

export default component.exports